import { all, fork } from "redux-saga/effects";

import { appSagas } from "./app/sagas";
import { applicationsSagas } from "./applications/sagas";
import { eventTrackingSagas } from "./event-tracking/sagas";
import { livechatIntegrationSagas } from "./livechat-integration/sagas";
import sessionSagas from "./session/sagas";
import { ticketActivitySagas } from "./ticket-activity/sagas";
import toastSagas from "./toasts/sagas";
import urlQueryParamsFeatureSaga from "./url-query-params/sagas";
import { websocketSagas } from "./websocket/sagas";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function* featuresSagas() {
  yield all([
    fork(appSagas),
    fork(toastSagas),
    fork(urlQueryParamsFeatureSaga),
    fork(sessionSagas),
    fork(eventTrackingSagas),
    fork(websocketSagas),
    fork(livechatIntegrationSagas),
    fork(ticketActivitySagas),
    fork(applicationsSagas),
  ]);
}
